/**
 * Payer Service (HealthCareFoundation/CoreServices/Payer) helpers for AgenticRCM.
 * Used by onboarding's payer-list upload step.
 */
import { getServiceApiUrl, SERVICE_PORTS } from '../utils/constants';

const getPayerApiBaseUrl = () => {
  const serviceBase = getServiceApiUrl('PAYER_SERVICE');
  if (serviceBase) {
    return `${serviceBase.replace(/\/$/, '')}/api/v1`;
  }
  if (typeof window !== 'undefined' && window.location) {
    const host = window.location.hostname;
    const isRemote = host !== 'localhost' && host !== '127.0.0.1';
    if (isRemote) return '/payer-api/v1';
    const port = SERVICE_PORTS?.PAYER_SERVICE?.BACKEND ?? 8109;
    return `${window.location.protocol}//${host}:${port}/api/v1`;
  }
  return 'http://localhost:8109/api/v1';
};

const getPayerRequestHeaders = () => {
  const headers = { 'Content-Type': 'application/json' };
  const token = localStorage.getItem('token') || localStorage.getItem('auth_token');
  if (token && String(token).trim().startsWith('eyJ')) {
    headers.Authorization = `Bearer ${String(token).trim()}`;
  }
  return headers;
};

const getOrganizationIdForPayer = () =>
  localStorage.getItem('selectedOrganizationId') || localStorage.getItem('organizationId') || null;

async function parseErrorResponse(res) {
  const text = await res.text();
  const isHtml = text.trim().toLowerCase().startsWith('<!');
  return isHtml
    ? `Payer Service returned an unexpected response (${res.status})`
    : text || `Payer Service returned ${res.status}`;
}

export const payerService = {
  /**
   * Bulk-add an uploaded list of payer names to this organization's
   * supported-payer list. `rows` is [{ name, identifier? }, ...].
   */
  async bulkImportOrganizationPayers(rows) {
    const orgId = getOrganizationIdForPayer();
    if (!orgId) {
      throw new Error('No organization selected — cannot import payer list.');
    }
    const base = getPayerApiBaseUrl();
    const res = await fetch(`${base}/organizations/${encodeURIComponent(orgId)}/payers/bulk-import`, {
      method: 'POST',
      headers: getPayerRequestHeaders(),
      body: JSON.stringify({ payers: rows }),
    });
    if (!res.ok) {
      throw new Error(await parseErrorResponse(res));
    }
    return res.json();
  },

  async listOrganizationPayers() {
    const orgId = getOrganizationIdForPayer();
    if (!orgId) return [];
    const base = getPayerApiBaseUrl();
    const res = await fetch(
      `${base}/organizations/${encodeURIComponent(orgId)}/payers?limit=500`,
      { headers: getPayerRequestHeaders() },
    );
    if (!res.ok) {
      throw new Error(await parseErrorResponse(res));
    }
    return res.json();
  },
};
